import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpManagerService } from '../httpmanager.service';
@Injectable()
export class BloguserService {
    constructor(private httpmanagerService: HttpManagerService) {
    }
    allbloguser(): Promise<any> {
        return this.httpmanagerService.HttpGet('bloguser', "").then(data => {
            if (data) {
                return data.data;
            }
        });
    }
    iblogger(admin): Promise<any> {
        return this.httpmanagerService.HttpPost('bloguser', JSON.stringify(admin), "").then(data => {
            return data;
        });
    }
    ubloggers(id, file, admin): Promise<any> {
        return this.httpmanagerService.HttpPostImageId('bloguser', JSON.stringify(admin), file, id).then(data => {
            return data;
        });
    }
    ublogger(id, admin): Promise<any> {
        return this.httpmanagerService.HttpPut('bloguser', JSON.stringify(admin), id).then(data => {
            return data;
        });
    }
    dblogger(id, admin): Promise<any> {
        return this.httpmanagerService.HttpPut('bloguser/deactive', JSON.stringify(admin), id).then(data => {
            return data;
        });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/bloguser/bloguser.service.ts